<div class="wrapper">
	<div class="header-section">
		<ion-row class="header">
			<ion-icon class="logo" src="../../../assets/topgolf/header_logo.svg"></ion-icon>
			<ion-icon (click)="close()" class="close" src="../../../assets/icon/white_cross.svg"></ion-icon>
		</ion-row>

		@if (customer) {
			<!-- <ng-container *ngIf="customer?.isAnonymous">
            <ion-row (click)="signIn()">
              <ion-icon src="../../../assets/topgolf/Login_Pink.svg"></ion-icon>
              <ion-col>
                {{ 'menu_popover.login' | translate }}
              </ion-col>
            </ion-row>
            <ion-row (click)="signUp()">
              <ion-icon src="../../../assets/topgolf/Register_Pink.svg"></ion-icon>
              <ion-col>
                {{ 'menu_popover.register' | translate }}
              </ion-col>
            </ion-row>
          </ng-container> -->
			<!-- <ion-row (click)="willBeSoon()">
            <ion-icon src="/assets/icon/cards.svg"></ion-icon>
            <ion-col>
              {{ 'menu_popover.payment_methods' | translate }}
            </ion-col>
          </ion-row> -->
			<!-- <ion-row (click)="account()" *ngIf="!customer?.isAnonymous">
                            <ion-icon src="../../../assets/topgolf/Register_Pink.svg"></ion-icon>
                            <ion-col>
                              {{ 'menu_popover.account' | translate }}
                            </ion-col>
                          </ion-row> -->
			<!-- <div class="logout-block" (click)="logout()" *ngIf="!customer?.isAnonymous">
                            {{ 'custom_translation.logout' | translate }}
                            </div> -->
			<!-- <a class="underline" href="/assets/allergens.pdf" target="_blank">
                            <ion-row class="menu-row">
                              <ion-icon src="/assets/icons-menu-modal/allergens.svg"></ion-icon>
                              <ion-col>
                                {{ 'menu_popover.allergens' | translate }}
                              </ion-col>
                            </ion-row>
                            </a> -->
		}

		@if (!customer) {
			<div>
				<ion-row class="ion-justify-content-center">
					<ion-spinner class="white" name="crescent"></ion-spinner>
				</ion-row>
			</div>
		}

		<ion-row (click)="privacy()">
			<ion-icon src="../../../assets/icons-menu-modal/privacy.svg"></ion-icon>
			<ion-col>
				{{ 'menu_popover.privacy' | translate }}
			</ion-col>
		</ion-row>
		<!-- <ion-row (click)="tos()">
        <ion-icon src="/assets/icons-menu-modal/faq.svg"></ion-icon>
        <ion-col>
          {{ 'menu_popover.terms' | translate }}
        </ion-col>
        </ion-row> -->

		<ng-container>
			<ion-row (click)="impressum()">
				<ion-icon src="/assets/icons-menu-modal/impressum.svg"></ion-icon>
				<ion-col>
					{{ 'menu_popover.imprint' | translate }}
				</ion-col>
			</ion-row>
		</ng-container>

		<!-- <ion-row (click)="accessibility()" *ngIf="!authLogin" role="button" tabindex="0">
        <ion-icon src="/assets/icons-menu-modal/privacy.svg" role="img" aria-label="accessibility icon"></ion-icon>
        <ion-col>
          {{ 'menu_popover.accessibility' | translate }}
        </ion-col>
        </ion-row> -->
	</div>

	<div class="footer-lang">
		<div (click)="changeLang(languageEnum.German)" [class.selected]="languageEnum.German === translate.currentLang">
			<ion-img class="flag" src="../../../assets/lang/de.svg"></ion-img>
			<span>DE</span>
		</div>
		<div (click)="changeLang(languageEnum.GreatBritain)" [class.selected]="languageEnum.GreatBritain === translate.currentLang">
			<ion-img class="flag" src="../../../assets/lang/en.svg"></ion-img>
			<span>EN</span>
		</div>
	</div>

	<div class="footer-section-desktop">
		<ion-button (click)="dismiss()">
			{{ 'menu_modal.close' | translate }}
		</ion-button>
	</div>
	<span class="version">{{ environment.version }}</span>
</div>
